import { Permissions, hasPermission } from './permissions.js';
/** Matches API admin route permission checks. */
export const SERVER_ADMIN_NAV_ITEMS = [
    { label: 'Overview', route: 'overview', permission: Permissions.MANAGE_SERVER },
    { label: 'Logs', route: 'logs', permission: Permissions.VIEW_AUDIT_LOG },
    { label: 'Members', route: 'members', permission: Permissions.MANAGE_MEMBERS },
    { label: 'Roles', route: 'roles', permission: Permissions.MANAGE_ROLES },
    { label: 'Channels', route: 'channels', permission: Permissions.MANAGE_CHANNELS },
    { label: 'Categories', route: 'categories', permission: Permissions.MANAGE_CHANNELS },
    { label: 'Ban List', route: 'bans', permission: Permissions.BAN_MEMBERS },
    { label: 'Timeouts', route: 'timeouts', permission: Permissions.TIMEOUT_MEMBERS },
    { label: 'Server Settings', route: 'general', permission: Permissions.MANAGE_SERVER },
    { label: 'Welcome Messages', route: 'welcome-messages', permission: Permissions.MANAGE_SERVER },
    { label: 'Emojis', route: 'emojis', permission: Permissions.MANAGE_SERVER },
];
export const SERVER_ADMIN_NAV_SECTIONS = [
    {
        heading: 'Server',
        items: SERVER_ADMIN_NAV_ITEMS.filter((i) => ['overview', 'general', 'welcome-messages', 'emojis', 'logs'].includes(i.route)),
    },
    {
        heading: 'Members',
        items: SERVER_ADMIN_NAV_ITEMS.filter((i) => ['members', 'roles', 'bans', 'timeouts'].includes(i.route)),
    },
    {
        heading: 'Content',
        items: SERVER_ADMIN_NAV_ITEMS.filter((i) => ['channels', 'categories'].includes(i.route)),
    },
];
export function filterServerAdminNavItems(userPermissions, items) {
    return items.filter((item) => hasPermission(userPermissions, item.permission));
}
export function filterServerAdminNavSections(userPermissions) {
    return SERVER_ADMIN_NAV_SECTIONS.map((section) => ({
        ...section,
        items: filterServerAdminNavItems(userPermissions, section.items),
    })).filter((section) => section.items.length > 0);
}
export function canAccessServerAdmin(userPermissions) {
    return filterServerAdminNavItems(userPermissions, SERVER_ADMIN_NAV_ITEMS).length > 0;
}
export function canAccessServerAdminRoute(userPermissions, route) {
    const item = SERVER_ADMIN_NAV_ITEMS.find((i) => i.route === route);
    if (!item)
        return false;
    return hasPermission(userPermissions, item.permission);
}
//# sourceMappingURL=server-admin-nav.js.map